import React, { useState } from "react";
import Header from "../layout/Header";
import Toolbar from "../navigation/Toobar";
import Chat from "../components/common/Chat";

function Turnover({ turnovers = [] }) {
  const [activeTab, setActiveTab] = useState("active");
  const isLoggedIn = !!localStorage.getItem("token");

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleString("en-US", options);
  };

  const activeTurnovers = turnovers.filter(
    (turnover) => turnover.status === "active"
  );
  const completedTurnovers = turnovers.filter(
    (turnover) => turnover.status === "complete"
  );

  // ✅ choose list dynamically
  const visibleTurnovers =
    activeTab === "active" ? activeTurnovers : completedTurnovers;

  return (
    <div className="v-application--wrap">
      <div>
        <div className="row no-gutters">
          <Header />
        </div>

        <div className="body">
          <div style={{ overflow: "hidden" }}>
            <div className="row hidden-md-and-up" style={{ height: "75px" }}>
              <div className="mobile-header text-center white--text col col-12">
                History
              </div>
            </div>

            <div className="row">
              <div className="historyContainer col col-12">
                <div data-v-3c387b18 className="history-overview-wrapper">
                  <div
                    data-v-3c387b18
                    className="turnover-message hidden-md-and-down"
                  >
                    Turnover amount display may be delayed. Please wait at least
                    five(5) minutes after your bets are settled
                  </div>

                  {/* 🔘 Menu with click logic only, no design change */}
                  <div
                    data-v-3c387b18
                    className="row filter-card-wrapper hidden-md-and-up no-gutters"
                  >
                    <div
                      data-v-3c387b18
                      className="d-flex col col-12"
                      style={{ gap: "1rem" }}
                    >
                      <div data-v-3c387b18 onClick={() => setActiveTab("active")}>
                        <div
                          data-v-3c387b18
                          tabIndex={0}
                          className={`game-menu-content v-card v-card--link v-sheet theme--dark ${
                            activeTab === "active" ? "selected" : ""
                          }`}
                          text
                          depressed
                        >
                          <div
                            data-v-3c387b18
                            className={`toStatus-card-image mx-auto ${
                              activeTab === "active" ? "selected" : ""
                            }`}
                            style={{
                              "--src": 'url("./icon/toRunning.svg")',
                            }}
                          >
                            <img
                              data-v-3c387b18
                              src="./icon/toRunning.png"
                              alt="Active"
                            />
                          </div>
                          <div
                            data-v-3c387b18
                            className="game-menu-title"
                          >
                            Active
                          </div>
                        </div>
                      </div>

                      <div
                        data-v-3c387b18
                        onClick={() => setActiveTab("complete")}
                      >
                        <div
                          data-v-3c387b18
                          tabIndex={0}
                          className={`game-menu-content v-card v-card--link v-sheet theme--dark ${
                            activeTab === "complete" ? "selected" : ""
                          }`}
                          text
                          depressed
                        >
                          <div
                            data-v-3c387b18
                            className={`toStatus-card-image mx-auto ${
                              activeTab === "complete" ? "selected" : ""
                            }`}
                            style={{
                              "--src": 'url("./icon/toCompleted.svg")',
                            }}
                          >
                            <img
                              data-v-3c387b18
                              src="./icon/toCompleted.png"
                              alt="Completed"
                            />
                          </div>
                          <div
                            data-v-3c387b18
                            className="game-menu-title"
                          >
                            Completed
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    data-v-3c387b18
                    className="desktop_card v-card v-sheet theme--dark elevation-0"
                  >
                    <div
                      data-v-3c387b18
                      className="turnover-message hidden-md-and-up mobile-to-message"
                    >
                      Turnover amount display may be delayed. Please wait at
                      least five(5) minutes after your bets are settled
                    </div>

                    <div
                      data-v-3c387b18
                      className="v-card v-sheet theme--dark elevation-0 history-card-mobile"
                    >
                      <div data-v-3c387b18 className="row no-gutters">
                        {visibleTurnovers.length > 0 ? (
                          <div
                            data-v-3c387b18
                            className="all-wallet-wrap px-2 col col-12"
                          >
                            {visibleTurnovers.map((turnover) => {
                              const progress =
                                turnover.required_turnover > 0
                                  ? (turnover.remaining_turnover /
                                      turnover.required_turnover) *
                                    100
                                  : 0;
                              return (
                                <div
                                  key={turnover.id}
                                  data-v-3c387b18
                                  id={`turnover-${turnover.id}`}
                                  title={
                                    turnover.transaction?.action === "bonus"
                                      ? turnover.transaction?.promotion?.name
                                      : "Regular Deposit"
                                  }
                                  className={`bonus-wallet-wrap ${
                                    turnover.status === "complete"
                                      ? "progressing"
                                      : "progressing"
                                  }`}
                                >
                                  <div
                                    data-v-3c387b18
                                    className="bonus-wallet"
                                  >
                                    <div
                                      data-v-3c387b18
                                      ui-key="title"
                                      className="title"
                                    >
                                      {turnover.transaction?.action === "bonus"
                                        ? turnover.transaction?.promotion?.name
                                        : "Regular Deposit"}
                                    </div>
                                    <div
                                      data-v-3c387b18
                                      className="card-detail"
                                    >
                                      <div
                                        data-v-3c387b18
                                        className="card-date end_time"
                                      >
                                        Event ends in:{" "}
                                        {formatDate(turnover.updated_at)}
                                      </div>
                                      <div
                                        data-v-3c387b18
                                        className="detail-btn"
                                      >
                                        <a data-v-3c387b18>
                                          <span data-v-3c387b18>Detail</span>
                                        </a>
                                      </div>
                                    </div>
                                    <div
                                      data-v-3c387b18
                                      className="wallet-inner"
                                    >
                                      <div
                                        data-v-3c387b18
                                        data-messagetype={1}
                                        data-id={16065131}
                                        className="wallet-inner-right"
                                      >
                                        <div
                                          data-v-3c387b18
                                          className="discount"
                                        >
                                          <div
                                            data-v-3c387b18
                                            className="currency-mobile"
                                          >
                                            ৳
                                          </div>
                                          <div
                                            data-v-3c387b18
                                            className="amount-current-mobile"
                                          >
                                            {turnover.remaining_turnover}
                                          </div>
                                          <div
                                            data-v-3c387b18
                                            className="symbol-mobile"
                                          >
                                            /
                                          </div>
                                          <div
                                            data-v-3c387b18
                                            className="currency-total-mobile"
                                          >
                                            ৳
                                          </div>
                                          <div
                                            data-v-3c387b18
                                            className="amount-total-mobile"
                                          >
                                            {turnover.required_turnover}
                                          </div>
                                        </div>

                                        <div
                                          data-v-3c387b18
                                          className="progress-group-mobile"
                                        >
                                          <div
                                            data-v-3c387b18
                                            className="progress"
                                          >
                                            <div
                                              data-v-3c387b18
                                              role="progressbar"
                                              aria-valuenow={progress}
                                              aria-valuemin={0}
                                              aria-valuemax={100}
                                              className="progress-bar"
                                              style={{
                                                width: `${progress}%`,
                                              }}
                                            />
                                          </div>
                                          <div
                                            data-v-3c387b18
                                            style={{
                                              marginLeft: "10px",
                                              color: "rgb(255, 206, 1)",
                                            }}
                                          >
                                            {progress.toFixed(2)}%
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <p
                            style={{
                              textAlign: "center",
                              width: "100%",
                              color: "#ccc",
                            }}
                          >
                            No {activeTab === "active" ? "Active" : "Completed"}{" "}
                            Data
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    data-v-3c387b18
                    className="row justify-center"
                  >
                    <div
                      data-v-3c387b18
                      role="dialog"
                      className="v-dialog__container"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Toolbar />
          <Chat />
        </div>
      </div>
    </div>
  );
}

export default Turnover;
